import { render, staticRenderFns } from "./AdWecomPopup.vue?vue&type=template&id=72b9e8c6&scoped=true"
import script from "./AdWecomPopup.vue?vue&type=script&lang=js"
export * from "./AdWecomPopup.vue?vue&type=script&lang=js"
import style0 from "./AdWecomPopup.vue?vue&type=style&index=0&id=72b9e8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b9e8c6",
  null
  
)

export default component.exports